import HomeLayout from '@/layouts/Home.vue'
export const RRHHRoutes = [
  {
    path: '/hr',
    name: 'hr',
    component: () => import('./views/EmployeesManagement.vue'),
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['RRHH', 'admin', 'supervisor', 'employee'],
    },
  },
]
